
import {
  REQUEST_BENEFITS,
  REQUEST_BENEFITS_SUCCESS,
  REQUEST_BENEFITS_FAILURE,
  FITNESS_GRANT_REGISTER_REQUEST,
  FITNESS_GRANT_REGISTER_SUCCESS,
  FITNESS_GRANT_REGISTER_FAILURE,
  GRANT_REGISTER_REQUEST,
  GRANT_REGISTER_SUCCESS,
  GRANT_REGISTER_FAILURE
} from 'constants/ActionTypes';

export default function BenefitsReducer(state = {
  benefitLoadingById: {},
  benefitRegisterError: null,
}, action) {
  switch (action.type) {
    case REQUEST_BENEFITS:
      return {
        ...state,
        isFetching: true,
        benefits: [],
        loaded: false,
      };

    case REQUEST_BENEFITS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        loaded: true,
      };

    case REQUEST_BENEFITS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        benefits: action.benefits,
        lastUpdated: action.receivedAt,
        loaded: true,
      };
    case FITNESS_GRANT_REGISTER_REQUEST:
      return {
        ...state,
        benefitLoadingById: {
          ...state.benefitLoadingById,
          [action.benefitId]: true,
        },
      };
    case FITNESS_GRANT_REGISTER_SUCCESS:
      return {
        ...state,
        benefitLoadingById: {
          ...state.benefitLoadingById,
          [action.benefitId]: false,
        },
      };
    case FITNESS_GRANT_REGISTER_FAILURE:
      return {
        ...state,
        benefitRegisterError: action.error,
        benefitLoadingById: {
          ...state.benefitLoadingById,
          [action.benefitId]: false,
        },
      };
    case GRANT_REGISTER_REQUEST:
      return {
        ...state,
      };
    case GRANT_REGISTER_SUCCESS:
      return {
        ...state,
      };
    case GRANT_REGISTER_FAILURE:
      return {
        ...state,
        benefitRegisterError: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/BenefitsReducer.js